<template>
  <el-button class="btn-delete" icon="el-icon-delete" @click="deleteData()">{{value}}</el-button>
</template>

<script>
export default {
  name: "button-delete-data",
  props: {
    value: {
      type: String,
      default: "删除"
    }
  },
  methods: {
    deleteData() {
      this.$emit("deleteSelection");
    }
  }
};
</script>

<style scoped>
.btn-delete {
  height: 32px;
  border: 1px solid #d7d7d7;
  color: #48576a;
  padding: 8px 16px;
  background-color: #f7f7f7;
  font-size: 13px;
}
.btn-delete:hover {
  color: #ffffff;
  background-color: #f25721;
}
</style>



// WEBPACK FOOTER //
// src/components/Button/ButtonDelete.vue